import {
  FilterMode,
  DashboardWidget_OrderBy,
  DashboardWidget,
  SortOrder,
  DashboardWidget_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const dashboardWidgetService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.dashboardWidgetOne({ id });
    return result.dashboardWidgetOne as DashboardWidget;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: DashboardWidget_OrderBy[] | null = null,
    filter: DashboardWidget_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: DashboardWidget_Filter | undefined;
    if (searchValue !== "") {
      where = {
        widgetKey: { contains: searchValue, mode: FilterMode.Insensitive },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.dashboardWidgetListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ widgetKey: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.dashboardWidgetListWithOffset
    ) as DashboardWidget[];
    return { list, orderBy };
  },
};
